import React, { useEffect, useReducer, useState } from 'react';
import ReactDOM from 'react-dom';
import LiveContext from '../../contexts/LiveContext';
import PrematchContext from '../../contexts/PrematchContext';
import { dataFetchReducer } from '../../data/data';
import FastbetCartContext from '../../data/fastbet/FastbetCartContext';
import { parseAutocompleteData } from '../../data/parseAutocompleteData';
import { filterSearchResults, positionPopupSearchBox } from '../../data/utils';
import { getLabel } from '../../data/labels';
import Loader from '../Loader';

export function groupResultsBySport(results) {
    const sports = [];
    const sportById = {};
    results.forEach(function(match) {
        if (sportById[match.sportRef] == null) {
            const sport = {
                id: match.sportRef,
                desc: match.sportDesc,
                tournaments: [],
                tournamentById: {},
            };
            sports.push(sport);
            sportById[match.sportRef] = sport;
        }
        const sport = sportById[match.sportRef];
        if (sport.tournamentById[match.tournamentRef] == null) {
            const tournament = {
                id: match.tournamentRef,
                desc: match.tournamentDesc,
                events: [],
            };
            sport.tournaments.push(tournament);
            sport.tournamentById[match.tournamentRef] = tournament;
        }
        const tournament = sport.tournamentById[match.tournamentRef];
        tournament.events.push(match);
    });

    return sports;
}

function MatchSearch(props) {
    const fastbetContext = React.useContext(FastbetCartContext);
    const prematchContext = React.useContext(PrematchContext);
    const liveContext = React.useContext(LiveContext);
    const [search, setSearch] = useState('');

    function handleChange(event) {
        setSearch(event.target.value);
    }

    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });

    useEffect(() => {
        if (search.length > 2 && state.data == null) {
        	let source = props.isLive? fastbetContext.getRawDataLive() : fastbetContext.getRawDataPrematch();
        	if (source != null) {
        		const parsedData = parseAutocompleteData(source, props.isLive);
        		dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });        		
        	} else {
        		 dispatch({ type: 'FETCH_FAILURE' });
        	}
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, state.data, props.isLive]);

    let results = [];
    if (search.length > 2 && state.data != null) {
        results = filterSearchResults(state.data, search, 'MATCH', function(match) {
            return match.desc;
        });

        const sports = groupResultsBySport(results);

        // If prematch, sort sports by ranking
        if (!props.isLive) {
            try {
                sports.sort((a, b) => {
                    const rankingA = props.data.sportById[a.id].ranking;
                    const rankingB = props.data.sportById[b.id].ranking;
                    return rankingA - rankingB;
                });
            } catch(e) {
                console.error(e);
            }
        }

        results = sports.map(function(sport) {
            return (
                <ul key={sport.id}>
                    <li className="autocomplete-search-results-popup-title">{sport.desc}</li>
                    <>
                        {sport.tournaments.map(function(tournament) {
                            return (
                                <React.Fragment key={tournament.id}>
                                    <li className="autocomplete-search-results-popup-title-2">{tournament.desc}</li>
                                    {tournament.events.map(function(match) {
                                        function handleClick() {
                                            if (props.isLive) {
                                                liveContext.openMatch(match.sportRef, match.categoryRef, match.tournamentRef, match.id);
                                                setSearch('');
                                            } else {
                                                const tournamentUniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
                                                prematchContext.openEvent(tournamentUniqueId, match)
                                                setSearch('');
                                            }
                                        }
                                        return (
                                            <li key={match.uniqueId} className="autocomplete-search-results-popup-title-3 pointer">
                                                <a href-disabled="#!" role="button" tabIndex="0"  onClick={handleClick}>{match.alias} - {match.desc}</a>
                                            </li>
                                        )
                                    })}
                                </React.Fragment>
                            )
                        })}
                    </>
                </ul>
            );
        });
    }

    const popupContainer = document.getElementById('autocomplete-search-results-id-1');
    if (popupContainer) {
        if (search.length > 2 && results.length > 0) {
            if (popupContainer.style.top === '') {
                positionPopupSearchBox(document.getElementById('match-search-input'), popupContainer);
            }
            popupContainer.style.display = '';
        } else {
            popupContainer.style.display = 'none';
        }
    }
    function handleFocus(){
    	if(!fastbetContext.isInitialized()){
    		fastbetContext.initialize();
    	}
    }
    
    return (
        <>
            <input type="search" 
            		id="match-search-input" 
            		name="ricerca" 
            		placeholder={fastbetContext.isLoading()? getLabel('general.loading') : getLabel('general.ricerca') } 
            		onChange={handleChange}
            		onFocus={handleFocus}
            		readOnly={!fastbetContext.isDataLoaded()}
            		value={search} />
            {(search.length > 2 || (search.length >= 2 && window.appConfig?.TERMINAL_AGENCY)) && results.length > 0 &&
                <>
                    {(state.isLoading || state.isError) ?
                        <Loader error={state.error} />
                        :
                        ReactDOM.createPortal(results, popupContainer)
                    }
                </>
            }
        </>
    );
}

export default MatchSearch;